<template>
    <a class="cta-link" :href="url" target="_blank">
      <div class="cta-flex">
        <span>{{text}}</span>
        <img class="cta-icon" src="../assets/cta-arrow.svg" alt="Click arrow" aria-hidden="true">
      </div>
    </a>
</template>

<script>
export default {
  name: 'Cta',
  props: ['text', 'url'],
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '~styles/vars';
  .cta-link {
    display: inline-flex;
    width: auto;
    padding: 16px 20px;
    border-radius: 2px;
    font-family: $fNational;
    font-size: 15px;
    line-height: 19px;
    color: $cWhite;
    text-decoration: none;
    box-shadow: 0px 4px 16px rgba(153, 0, 0, 0.3);
    background: linear-gradient(to right, #CC0000, #990000);
    overflow: hidden;
    position: relative;
    transition: box-shadow .3s ease-in-out;
    z-index: 1;
    margin-bottom: 16px;
  }
  .cta-flex {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cta-link::before,
  .cta-link::after {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: linear-gradient(to right, #CC0000, #990000);
    border-radius: 2px;
    z-index: -1;
  }
  .cta-link:after {
    opacity: 0;
    background: linear-gradient(to right, #CC0000, #CC0000);
    transition: opacity.3s ease-in-out;
  }
  .cta-link:hover::before {
    opacity: 0;
  }
  .cta-link:hover {
    box-shadow: 0px 4px 16px rgba(153, 0, 0, 0.6);
    transition: box-shadow .3s ease-in-out;
  }
  .cta-link:hover::after {
    opacity: 1;
  }
  .cta-link:active:after,
  .cta-link:active:before {
    background: linear-gradient(to right, #990000, #990000) !important;
  }
  .cta-icon {
    width: 12px;
    min-width: 12px;
    height: 16px;
    margin-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Cta.vue